<app-history-sheet-container>
  <div class="flex h-full w-full" appHistoryShortcut>
    @if (isAdmin) {
      <app-sidebar />
    }

    <div class="relative flex h-screen grow flex-col overflow-auto">
      @if (!fullscreenMode()) {
        <app-header />

        <app-banner />

        <app-breadcrumb />
      }

      <div
        class="px-2 pb-[100px] xl:pl-6 xl:pr-[60px]"
        [ngClass]="{
          'py-2': fullscreenMode(),
          'pb-5': !fullscreenMode(),
        }"
      >
        <ng-content />
      </div>
    </div>
  </div>
</app-history-sheet-container>

@if (!isAdmin) {
  <app-agent-chat-launcher />
}
